import * as React from "react";
import { TokenModel } from "./model/autogen/TokenModel";
import { IFetcher, IUserDetails } from "./components/with-auth-context";
import { UserLevel } from "./model/autogen/UserLevel";

const STORAGE_KEY: string = "token";
const REFRESH_KEY: string = "refresh";

export function getToken(): string | undefined {
    const token = window.localStorage.getItem(STORAGE_KEY);
    if (token) {
        return token;
    }
    return undefined;
}
export function getRefreshToken() {
    return window.localStorage.getItem(REFRESH_KEY);
}

export function setToken(model: TokenModel | undefined) {
    if (model) {
        window.localStorage.setItem(STORAGE_KEY, model.token);
        window.localStorage.setItem(REFRESH_KEY, model.refreshToken);
    } else {
        delete window.localStorage[STORAGE_KEY];
        delete window.localStorage[REFRESH_KEY];
    }
}

export function removeToken(): void {
    window.localStorage.removeItem(STORAGE_KEY);
    window.localStorage.removeItem(REFRESH_KEY);
}

export function isLoggedOn() { return !!getToken(); }

export interface IAuthContextState {
    readonly token: string | undefined;
    readonly user: IUserDetails;
    readonly loading: boolean;
}

export interface IAuthContext {
    readonly state: IAuthContextState,
    methods: {
        setToken: (token: TokenModel | undefined) => void;
        invokeApi: <T = any>(serviceMethod: (fetcher: IFetcher) => Promise<T>) => Promise<T>;
        initLogin: (username: string, password: string, onError: (err: any) => void, onSuccess: () => void) => void;
        recoveryLogin: (username: string, password: string, onError: (err: any) => void) => void;
        getUserInfo: () => any;

            
        /** Development only feature to set the user level during testing. NOTE This should be removed before going live. */
        setLevel: (level: UserLevel) => void;
    }
}


export function parseJwt (token: string) {
    try {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    } catch (e) {
        return undefined;
    }
};

export const AuthContext = React.createContext<IAuthContext>({
    state: { token: '', user: { level: UserLevel.Disabled, id: null}, loading: false },
    methods: {} as any
});


// WEBPACK FOOTER //
// ./src/auth-context.ts